import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

import ListCustomers from "./ListCustomers.js"
import ViewCustomer from "./ViewCustomer.js"
import CreateCustomer from "./CreateCustomer.js"
import EditCustomer from "./EditCustomer.js"




export default function Users() {

    return (
        <Routes>
            <Route path="/" element={<ListCustomers />} />
            <Route path="/view/:id" element={<ViewCustomer />} />
            <Route path="/edit/:id" element={<EditCustomer />} />
            <Route path="/create/" element={<CreateCustomer />} />
        </Routes>
    )
}


